
import React from "react";
import { Vision } from "@/components/home/Vision";
import { Features } from "@/components/home/Features";
import { EnvironmentAction } from "@/components/home/EnvironmentAction";
import { VideoPresentation } from "@/components/home/VideoPresentation";
import { Hero } from "@/components/home/Hero";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-24"> {/* Add padding-top to make room for the fixed header */}
        <Hero />
        <Vision />
        <VideoPresentation />
        <Features />
        <EnvironmentAction />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
